import React, { useContext } from 'react';
import classNames from 'classnames';
import { Button, Dropdown } from 'ncoded-component-library';
import { useTranslation } from 'react-i18next';
import FolderIcon from 'icons/Folder.icon';
import useMatchMedia from 'hooks/useMatchMedia';
import FolderPlusIcon from 'icons/FolderPlus.icon';
import CloudUploadIcon from 'icons/CloudUpload.icon';
import DataRoomDocumentsContext from '../../providers/DataRoomDocuments/DataRoomDocuments.context';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import PluscircleIcon from 'icons/Pluscircle.icon';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useNavigate } from 'react-router-dom';
import ChecklistIcon from 'icons/Checklist.icon';
import { getDataRoomRoute } from 'utils';
import { DATA_ROOM_INPUT_ID } from 'data/global';
import DataRoomUploadContext from 'router/subrouters/DataRoom/providers/DataRoomUpload/DataRoomUpload.context';

import './DataRoomUploadActions.styles.scss';
import './DataRoomUploadActions.styles.responsive.scss';

type DataRoomUploadActionsProps = {
  className?: string;
  hideBuySideViewAS?: boolean;
};

const DataRoomUploadActions: React.FC<DataRoomUploadActionsProps> = (props) => {
  const { className } = props;

  const {
    isPublishingAllowed,
    isAdmin,
    dataRoom: { _id },
  } = useContext(DataRoomContext);
  const { onUploadClick } = useContext(DataRoomUploadContext);
  const { addAFolderModal } = useContext(DataRoomDocumentsContext);

  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>();

  const navigate = useNavigate();

  const { t } = useTranslation();

  const isAbovePhablet = useMatchMedia('isAbovePhablet');

  const classes = classNames('data-room-upload-actions', className);

  if (!isPublishingAllowed) return null;

  return (
    <Dropdown
      ref={dropdownRef}
      renderAsPortal
      trigger={
        <Button
          icon={PluscircleIcon}
          className="data-room-upload-actions-trigger"
        >
          {t('add')}
        </Button>
      }
    >
      <div className={classes}>
        <Button
          variant="outline"
          icon={FolderPlusIcon}
          onClick={() => {
            dropdown.setIsOpen(false);
            addAFolderModal.open();
          }}
        >
          {t('createAFolder')}
        </Button>

        {isAbovePhablet && (
          <label htmlFor={DATA_ROOM_INPUT_ID}>
            <FolderIcon />
            {t('uploadAFolder')}
          </label>
        )}

        <Button
          variant="outline"
          icon={CloudUploadIcon}
          onClick={(event) => {
            dropdown.setIsOpen(false);
            onUploadClick(event);
          }}
        >
          {t('uploadFiles')}
        </Button>

        {isAdmin && (
          <Button
            variant="outline"
            icon={<ChecklistIcon strokeWidth={2} />}
            onClick={() => {
              navigate(getDataRoomRoute(_id, 'rfi/create'));
            }}
          >
            {t('requestFiles')}
          </Button>
        )}
      </div>
    </Dropdown>
  );
};

export default DataRoomUploadActions;
